import { z } from 'zod';
import { operatorApiFetch } from './apiService';
import { apiList } from '@services/apiSchemas';

// 對應 app/controllers/api/operator/v1/inventory_attribute_definitions_controller.rb#index
//   render_data_list(scope.order(:position)) — model 預設 as_json 直接吐 DB columns
export const InventoryAttributeDefinitionSchema = z.object({
  id: z.string(),
  organization_id: z.string(),
  merchant_id: z.string(),
  name: z.string(),
  label: z.string(),
  data_type: z.string(),
  options: z.unknown(),
  required: z.boolean(),
  position: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
}).passthrough();

export type InventoryAttributeDefinition = z.infer<typeof InventoryAttributeDefinitionSchema>;

export const inventoryAttributeDefinitionService = {
  list: async (params: Record<string, unknown> = {}) => {
    const response = await operatorApiFetch('inventory_attribute_definitions', { params });
    return apiList(InventoryAttributeDefinitionSchema).parse(await response.json());
  },

  fetchList: async (params: Record<string, unknown> = {}) => {
    const response = await operatorApiFetch('inventory_attribute_definitions', { params });
    return apiList(InventoryAttributeDefinitionSchema).parse(await response.json());
  },
};

export default inventoryAttributeDefinitionService;
